import React, { useEffect, useState } from "react";
import axios from "axios";
import Topbar from "../components/topbar";
import Sidebar from "../components/sidebar";
import Footer from "../components/footer";

const Dashboard = () => {

  const BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const API_COUNT = `${BASE_URL}admin/getdata/getdashboard_count.php`;
  const API_BOOKING = `${BASE_URL}admin/getdata/get_dashboardbooking.php`;

  /* ================= STATES ================= */
  const [counts, setCounts] = useState({
    pending: 0,
    confirm: 0,
    rooms: 0,
  });

  const [bookings, setBookings] = useState([]);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");

  /* ================= FETCH COUNTS ================= */
  const fetchCounts = async () => {
    try {
      const res = await axios.get(API_COUNT);
      if (res.data.success) {
        setCounts(res.data.data);
      }
    } catch (error) {
      console.error("Error loading dashboard counts:", error);
    }
  };

  /* ================= FETCH BOOKINGS ================= */
  const fetchBooking = async () => {
    setLoading(true);
    setMessage("");

    try {
      const res = await axios.get(API_BOOKING, {
        params: {
          action: "list",
          fromDate,
          toDate,
        },
      });

      // PDO version returns plain array
      if (Array.isArray(res.data)) {
        setBookings(res.data);
      } else {
        setBookings([]);
      }

    } catch (err) {
      console.error(err);
      setMessage("Error loading bookings");
    } finally {
      setLoading(false);
    }
  };

  /* ================= LOAD ON MOUNT ================= */
  useEffect(() => {
    fetchCounts();
    fetchBooking();
  }, []);

  return (
    <div className="header-light sidebar-dark sidebar-expand">
      <Topbar />
      <div className="content-wrapper">
        <Sidebar />

        <main className="main-wrapper clearfix">
          <div className="widget-list">

            {/* ================= CARDS ================= */}
            <div className="row g-4">

              {/* Pending */}
              <div className="col-12 col-md-6 col-xl-4">
                <div className="card bg-primary text-white shadow h-100">
                  <div className="card-body d-flex justify-content-between align-items-center">
                    <div>
                      <h6 className="text-uppercase mb-1">Pending Bookings</h6>
                      <h3 className="mb-0 fw-bold">
                        {counts.pending.toLocaleString()} Nos.
                      </h3>
                    </div>
                    <i className="bi bi-book fs-1 opacity-50" style={{ fontSize: "2.5rem" }}></i>
                  </div>
                </div>
              </div>

              {/* Confirm */}
              <div className="col-12 col-md-6 col-xl-4">
                <div className="card bg-success text-white shadow h-100">
                  <div className="card-body d-flex justify-content-between align-items-center">
                    <div>
                      <h6 className="text-uppercase mb-1">Confirm Bookings</h6>
                      <h3 className="mb-0 fw-bold">
                        {counts.confirm.toLocaleString()} Nos.
                      </h3>
                    </div>
                    <i className="bi bi-check-circle fs-1 opacity-50" style={{ fontSize: "2.5rem" }}></i>
                  </div>
                </div>
              </div>

              {/* Rooms */}
              <div className="col-12 col-md-6 col-xl-4">
                <div className="card bg-warning text-white shadow h-100">
                  <div className="card-body d-flex justify-content-between align-items-center">
                    <div>
                      <h6 className="text-uppercase mb-1">Executive Rooms</h6>
                      <h3 className="mb-0 fw-bold">
                        {counts.rooms.toLocaleString()} Nos.
                      </h3>
                    </div>
                    <i className="bi bi-house fs-1 opacity-50" style={{ fontSize: "2.5rem" }}></i>
                  </div>
                </div>
              </div>

            </div>

            <br />

            {/* ================= BOOKING TABLE ================= */}
            <div className="row">
              <div className="col-md-12 widget-holder widget-full-height">
                <div className="widget-bg">
                  <div className="widget-body clearfix">

                    <h5 className="box-title">Total Bookings</h5>

                    <div className="padded-reverse">

                      {loading ? (
                        <p>Loading bookings...</p>
                      ) : (
                        <table className="table table-striped widget-status-table mr-b-0">
                          <thead className="table-light">
                            <tr>
                              <th>#</th>
                              <th>Summary</th>
                              <th>Name</th>
                              <th>Phone</th>
                              <th>Check-in</th>
                              <th>Check-out</th>
                              <th>Rooms</th>
                              <th>Total Price</th>
                              <th>Status</th>
                            </tr>
                          </thead>

                          <tbody>
                            {bookings.length > 0 ? (
                              bookings.map((item, index) => (
                                <tr key={item.id}>
                                  <td>{index + 1}</td>
                                  <td>{item.summary}</td>
                                  <td>{item.name}</td>
                                  <td>{item.phone}</td>
                                  <td>{item.checkin_date}</td>
                                  <td>{item.checkout_date}</td>
                                  <td>{item.noof_room}</td>
                                  <td>₹{item.total_price}</td>

                                  <td>
                                    {item.status === "pendings" && (
                                      <span className="badge bg-danger">
                                        Pending
                                      </span>
                                    )}

                                    {item.status === "confirm" && (
                                      <span className="badge bg-success">
                                        Confirm
                                      </span>
                                    )}
                                  </td>
                                </tr>
                              ))
                            ) : (
                              <tr>
                                <td colSpan="9" className="text-center">
                                  No bookings found
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      )}

                      {message && (
                        <div className="alert alert-danger mt-2">
                          {message}
                        </div>
                      )}

                    </div>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </main>

        <Footer />
      </div>
    </div>
  );
};

export default Dashboard;